// src/apis/publicApi.js
// Public read-only calls to the Lambda Function URL.
// No auth header, no API key — used by gallery and profile for unauthenticated visitors.

const BASE = (process.env.REACT_APP_PUBLIC_API_URL || "").replace(/\/$/, "");

export const fetchPublicGallery = async ({ tenantId }) => {
  const res = await fetch(`${BASE}/gallery?tenantId=${encodeURIComponent(tenantId)}`);
  if (!res.ok) throw new Error(`Gallery fetch failed: ${res.status}`);
  return res.json();
};

export const fetchPublicProfile = async ({ tenantId }) => {
  const res = await fetch(`${BASE}/profile?tenantId=${encodeURIComponent(tenantId)}`);
  if (!res.ok) throw new Error(`Profile fetch failed: ${res.status}`);
  return res.json();
};

export const fetchPublicStore = async ({ tenantId }) => {
  const res = await fetch(`${BASE}/store?tenantId=${encodeURIComponent(tenantId)}`);
  if (!res.ok) throw new Error(`Store fetch failed: ${res.status}`);
  return res.json();
};

export const createCheckoutSession = async ({ tenantId, entityId, title, price, imageUrl, type }) => {
  const res = await fetch(`${BASE}/checkout`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tenantId, entityId, title, price, imageUrl, type }),
  });
  if (!res.ok) throw new Error(`Checkout session failed: ${res.status}`);
  return res.json(); // { url }
};
